import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";


const MultiSelectField = ({ field, formState, setFormState, fieldsConfig, searchValues, setSearchValues, activeDropdown, setActiveDropdown, dropdownRefs }) => {

    const [selectingDeselectingLoading, setSelectingDeselectingLoading] = useState(false);

    let debounce;

    // Handle search input changes
    const handleSearchChange = (alias, value) => {

        setSearchValues(prev => ({ ...prev, [alias]: value }));

    };

    // Toggle dropdown visibility
    const toggleDropdown = (alias, forceOpen = false) => {
        if(!forceOpen)
            setActiveDropdown(activeDropdown === alias ? null : alias);
        else
            setActiveDropdown(alias);
    };

    // Toggle item selection
    const toggleItemSelection = (alias, itemValue) => {
        setFormState(prev => {
            const currentValues = prev[alias] || [];
            const newValues = currentValues.includes(itemValue)
            ? currentValues.filter(v => v !== itemValue)
            : [...currentValues, itemValue];
      
            return { ...prev, [alias]: newValues };
        });
        setSearchValues(prev => ({ ...prev, [alias]: '' }));
    };

    // Select all items for a field
    const selectAllItems = (alias) => {
        const field = fieldsConfig.find(f => f.Alias === alias);
        if (!field) return;

        setSelectingDeselectingLoading(true);

        setTimeout(() => {


            let currentSearch = searchValues[alias];

            setFormState(prev => {
                const newState = {
                    ...prev,
                    [alias]: field.Items.map(item => item.Value) // Add all, not filtered
                    //[alias]: field.Items.filter(item => item.Text.toLowerCase().includes(currentSearch.toLowerCase())).map(item => item.Value) // Add all, filtered
                };
    
                // This callback runs after the state update is complete
                setTimeout(() => {
                    setSelectingDeselectingLoading(false);
                }, 0);
    
                return newState;
            });

            // Close dropdown
            toggleDropdown(alias);

        }, 0);

    };

    // Deselect all items for a field
    const deselectAllItems = (alias) => {

        setSelectingDeselectingLoading(true);

        setTimeout(() => {

            setFormState(prev => {
                const newState = {
                    ...prev,
                    [alias]: []
                };
    
                // This callback runs after the state update is complete
                setTimeout(() => {
                    setSelectingDeselectingLoading(false);
                }, 0);
    
                return newState;
            });

        }, 0);


    };

    // Filter items based on search
    const getFilteredItems = (alias) => {

        const field = fieldsConfig.find(f => f.Alias === alias);
        if (!field) return [];
    
        const searchValue = searchValues[alias] || '';
        return field.Items.filter(item =>
            item.Text.toLowerCase().includes(searchValue.toLowerCase())
        );
    };



    
    // Click outside handler with proper cleanup
    useEffect(() => {
        const handleClickOutside = (event) => {
            let isOutside = true;
            Object.values(dropdownRefs.current).forEach(ref => {
            if (ref?.contains(event.target)) {
                isOutside = false;
            }
            });
            if (isOutside) setActiveDropdown(null);
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);






    return <>

            <div key={field.Alias} className="form-field">
                <label className="create-sr-field-title">
                    {field.Name}
                    {(() => {
                        const selectedCount = formState[field.Alias]?.length || 0;
                        return selectedCount > 0 && <span className="selected-count">({selectedCount} selected)</span>;
                    })()}
                </label>
            
            {/* Search input and selected tags */}
            <div className="search-container">
                <input
                    type="text"
                    placeholder={formState[field.Alias].length == 0 ? `All ${field.Name}` : `Add ${field.Name}...`}
                    value={searchValues[field.Alias] || ''}
                    onChange={(e) => handleSearchChange(field.Alias, e.target.value)}
                    onFocus={() => toggleDropdown(field.Alias, true)}
                    onClick={() => toggleDropdown(field.Alias, true)}
                />
              
                {/* Selected tags */}
                <div className="selected-tags">
                {formState[field.Alias]?.slice(0,10).map(value => {
                    const item = field.Items.find(i => i.Value === value);
                    return item ? (
                    <span key={value} className="tag">
                        {item.Text}
                        <button
                        type="button"
                        onClick={() => toggleItemSelection(field.Alias, value)}
                        className="tag-remove"
                        >
                        ×
                        </button>
                    </span>
                    ) : null;
                })}
                {
                    formState[field.Alias]?.length > 10 ? <span className="tag-remaining-items">...and {formState[field.Alias]?.length - 10} more.</span> : null
                }
                </div>
            </div>
            
            {/* Dropdown with items */}
            {activeDropdown === field.Alias && (
                <div
                    ref={el => dropdownRefs.current[field.Alias] = el}
                    className="dropdown-container">

                <div className="dropdown-actions">
                    {
                        selectingDeselectingLoading ? <LoadingSpinnerImage /> : <>
                            <button
                                style={{display: "none"}}
                                type="button"
                                onClick={() => selectAllItems(field.Alias)}
                                className="select-all"
                                >
                                Select All
                            </button>
                            <button
                                style={{display: "none"}}
                                type="button"
                                onClick={() => deselectAllItems(field.Alias)}
                                className="deselect-all"
                                >
                                Deselect All
                            </button>
                        </>
                    }
                </div>

                <div className="dropdown-items">
                    {getFilteredItems(field.Alias).map(item => (
                    <div
                        key={item.Value}
                        className={`dropdown-item ${formState[field.Alias]?.includes(item.Value) ? 'selected' : ''}`}
                        onClick={() => toggleItemSelection(field.Alias, item.Value)}
                    >
                        <input
                        type="checkbox"
                        checked={formState[field.Alias]?.includes(item.Value) || false}
                        readOnly
                        />
                        {item.Text}
                    </div>
                    ))}
                </div>
                </div>
            )}
            </div>

        </>


}

export default MultiSelectField;